import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ClipLoader} from 'react-spinners';

import './styles.scss';

class Loader extends Component {
  render = () => {
    const {loading} = this.props;
    return loading ? (
      <div className="loading">
        <ClipLoader sizeUnit={'px'} size={100} color={'#FFF'} />
      </div>
    ) : null;
  };
}

const mapStateToProps = ({loader}) => loader;

export default connect(mapStateToProps, null)(Loader);
